import { SVGProps } from '@components/Icon/types';

export const Language = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73575 3.76226L10.0424 9.98409L10.0654 10.0451H8.51613L8.50552 10.0141L7.97437 8.44543H5.73221L5.20194 10.0141L5.19134 10.0451H3.71277L3.73575 9.98409L6.05214 3.76226L6.06363 3.7331H7.72514L7.73575 3.76226ZM6.04596 7.4388H7.67123L6.85815 5.01989L6.04596 7.4388Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7419 0C12.8664 0 13.7781 0.911755 13.7782 2.03624V6.22183H17.4662C18.8656 6.22183 19.9999 7.35626 20 8.75563V17.4662C20 18.8657 18.8657 20 17.4662 20H8.75563C7.35626 19.9999 6.22183 18.8656 6.22183 17.4662V13.7782H2.03624C0.911755 13.7781 0 12.8664 0 11.7419V2.03624C0.000119378 0.911829 0.911829 0.000119378 2.03624 0H11.7419ZM13.7782 9.7057H17.5113V11.0994H16.0053C15.5141 12.448 14.8531 13.5553 14.0239 14.4755C14.9596 15.1911 16.1006 15.7282 17.4759 16.0389L17.5555 16.0574L17.498 16.1149C17.2351 16.3803 16.8882 16.8973 16.7238 17.2108L16.707 17.2426L16.6726 17.2338C15.1983 16.8547 14.0034 16.2363 13.0358 15.4158C12.0332 16.217 10.8503 16.817 9.46001 17.2603L9.42112 17.2726L9.40521 17.2355C9.27824 16.9519 8.93941 16.4352 8.72028 16.1679L8.67609 16.1131L8.74414 16.0954C10.0839 15.739 11.2151 15.219 12.1326 14.5223C11.9308 14.2864 11.7402 14.0382 11.5608 13.7782H7.55634V17.4662C7.55634 18.1284 8.09348 18.6654 8.75563 18.6655H17.4662C18.1284 18.6655 18.6655 18.1284 18.6655 17.4662V8.75563C18.6654 8.09348 18.1284 7.55634 17.4662 7.55634H13.7782V9.7057ZM13.7782 11.7419C13.7782 12.4346 13.4315 13.0454 12.9032 13.4132C12.9675 13.4882 13.0339 13.5617 13.1012 13.6341C13.7308 12.9355 14.2342 12.0997 14.6186 11.0994H13.7782V11.7419ZM2.03624 1.08617C1.51161 1.08629 1.08629 1.51161 1.08617 2.03624V11.7419C1.08617 12.2667 1.51153 12.6919 2.03624 12.692H11.7419C12.2667 12.692 12.692 12.2667 12.692 11.7419V2.03624C12.6919 1.51153 12.2667 1.08617 11.7419 1.08617H2.03624Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'language';
